import { Itinerary2 } from '~/models/Itinerary'
import { ProfileService } from '~/passporter-services/profile/service'
import { useProfileTrips } from '~/store/profileTrips'
export class ProfileTripActions {
	public static async getLastUpdatedTrip(profileId: string): Promise<Itinerary2 | undefined> {
		try {
			const stored = this.profileTripsStore().getLastUpdatedTrip()
			if (stored) return stored
			const lastUpdatedTrip = await ProfileService.getLastUpdatedTrip(profileId)
			this.profileTripsStore().addLastUpdatedTrip(lastUpdatedTrip)
			return lastUpdatedTrip
		} catch {
			console.error('Error getting last updated trip')
		}
	}

	private static profileTripsStore() {
		return useProfileTrips()
	}
}
